import * as types from '../mutation-types'

export const state = {
    nav: false,
    toggleCurrency: false,
    pending_number: 0,
}

export const getters = {
    nav: state => state.nav,
    pending_number: state => state.pending_number,
    toggleCurrency: state => state.toggleCurrency,
}

export const mutations = {
    [types.NAV_MENU](state, payload) {
        state.nav = payload
    },
    [types.TOGGLE_CURRENCY](state, payload) {
        state.toggleCurrency = payload
    },
    [types.PENDING_NUMBER](state, payload) {
        state.pending_number = payload
    }
}
export const actions = {
    setPendingNumber({ commit }, payload) {
        commit(types.PENDING_NUMBER, payload)
    },
    nav_menu({ commit, getters }, payload) {
        commit(types.NAV_MENU, !getters.nav)
    },
    SetToggleCurrency({ commit, getters }, payload) {
        commit(types.TOGGLE_CURRENCY, !getters.toggleCurrency)
    }
}
